module.exports = __webpack_public_path__ + "img/default_bgimg.c996f0e3.jpg";